import React from "react";
import "./header.scss";

/* REDUX */
import { useSelector, useDispatch } from "react-redux";
import {
  showModal,
  fetchAdminRequest,
  fetchAdminReportedSuccess,
  fetchAdminReportedFailure,
} from "../../redux/actions";

/* COMPONENTS */
import { withRouter } from "react-router-dom";
import Logo from "../../assets/Logo-KZVB-RGB.svg";
import Button from "../../components/button/button";
import axios from "axios";
import { toast } from "react-toastify";

const Header = ({ history }) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const fetchAdminUsers = async () => {
    dispatch(fetchAdminRequest());

    try {
      // SET AUTH HEADER
      axios.defaults.headers.common["x-auth-token"] = sessionStorage.getItem(
        "kzvb-obleute"
      );

      const res = await axios.get("/api/v1/users?reported=true");
      dispatch(fetchAdminReportedSuccess(res.data));
    } catch (err) {
      console.log(err.message);
      toast.error("Internal server error");
      dispatch(fetchAdminReportedFailure());
    }
  };

  return (
    <header className='header'>
      <img
        src={Logo}
        alt='KZVB LOGO'
        className='header__logo'
        onClick={() => window.open("https://www.kzvb.de", "_blank")}
      />
      <div className='header__menu'>
        <Button
          className='button-primary mr-2'
          text='Startseite'
          icon='home-3'
          onClick={() => history.push("/")}
        />
        {user.data && (
          <Button
            className='button-primary'
            text='Einstellungen'
            icon='cogs'
            onClick={() => {
              user.data.admin && fetchAdminUsers();
              dispatch(showModal("Einstellungen", "settings", "m"));
            }}
          />
        )}
      </div>
    </header>
  );
};

export default withRouter(Header);
